import { Section } from '@ahmdigital/ui';
import styled from 'styled-components';

export const ContentContainer = styled.div`
  position: relative;
`;

export const SectionContainer = styled(Section)`
  padding-top: 0;
  position: relative;
  z-index: 1;
`;

export const SectionWrapper = styled.div`
  padding-top: 2rem;
`;
